module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"時間別来店客数傾向"}}')
  delete Component.options._Ctor
}
